import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EditPoi from './EditPOI';
// import {BootstrapTable,TableHeaderColumn} from 'react-bootstrap-table';
import RCPagination from '../../UserControl/Pagination/RCPagination';
import { checkStatus,checkPrivileges } from '../../../../util/util';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import '../POI/css/react-bootstrap-table-all.min.css';
import {Alert} from '../../../Modals/AlertBar';

class NearTrackingList extends Component {

    constructor() {
        super();

        this.state = {
            dataPoi:[],
            poiName:'',
            deviceSelectID:null,
            isShowEdit:false,
            isShowNew:false,
            currentPage:1,
            currentPageSize:10,
            totalPage:0,
            poiId:'',
        };
    }

    componentWillMount(){
        let id = this.props.poiId;
        this.setState({
            poiId:id,
        })
    }

    componentDidMount() {
        // this.getPOIList();
        // this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
        console.log('componentDidMount')
        this.getNearTrackingList();
    }

    componentWillUnmount() {
        this.setState({dataPoi: [], poiName: ''});
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.poiId !== this.props.poiId ) {

            let id = nextProps.poiId;
            this.state.poiId=id;
            this.getNearTrackingList();
        }
    }

    // onPageSelect(page){

    //     //fetch http://{server}/api/admin/xxxx/{page}/{this.state.currentPageSize}
    //     //then this.setState({deviceList:data,currentPage:page})

    //     // let data=tmpdeviceList.slice((page-1)*this.state.currentPageSize,((page-1)*this.state.currentPageSize)+this.state.currentPageSize)
    //     // this.setState({deviceList:data,currentPage:page})
    //    // console.log('onPageSelect',data,(page-1)*this.state.pageSize,((page-1)*this.state.pageSize)+this.state.pageSize);
    //    const { currentPageSize } = this.state;
    //    const { user_id, user_name,token} = this.props;
    //    fetch(`http://203.150.199.244/api/admin/getPOIList/${page}/${currentPageSize}`, {
    //        method: 'post',
    //        headers: {
    //         //    "Content-Type": "application/json; charset=utf-8",
    //         //    "user_id": user_id,
    //         //    "user_name": user_name,
    //         //    "token": token
    //         "Content-Type": "application/json; charset=utf-8",
    //         "user_id": '1',
    //         "user_name": 'Wutthin',
    //         "token": 'admin'
    //        },
    //        body: JSON.stringify({
    //            // "filter":name
    //        })
    //        })
    //        .then(response => { return checkStatus(response)})
    //        .then(data => {
    //            this.setState({
    //                deviceList:data.RESULT_DATA,
    //                totalPage:data.RESULT_TOTAL,
    //                currentPage:page,currentPageSize:currentPageSize})

    //        })
    //        .catch(function (err) {
    //            console.log('err:', err);
    //            // POST failed...
    //        });
   
    // }
    // onPageSizeChange(page, pageSize){
    //     // fetch http://{server}/api/admin/xxxx/{page}/{this.state.currentPageSize}
    //     // then this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})


    //     const name = this.state.poiName;
    //     const { user_id, user_name,token} = this.props;

    //     fetch(`http://203.150.199.244/api/admin/getPOIList/${page}/${pageSize}`, {
    //         method: 'post',
    //         headers: {
    //         //     "Content-Type": "application/json; charset=utf-8",
    //         //    "user_id": user_id,
    //         //    "user_name": user_name,
    //         //    "token": token
    //         "Content-Type": "application/json; charset=utf-8",
    //         "user_id": '1',
    //         "user_name": 'Wutthin',
    //         "token": 'admin'
    //         },
    //         body: JSON.stringify({
    //             "filter":name
    //         })
    //         })
    //         .then(response => { return checkStatus(response)})
    //         .then(data => {
    //             this.setState(
    //                 {dataPoi:data.RESULT_DATA,
    //                 totalPage:data.RESULT_TOTAL,
    //                 currentPage:page,currentPageSize:pageSize}
    //             )

    //         })
    //         .catch(function (err) {
    //             console.log('err:', err);
    //             // POST failed...
    //         });



    //     // let data=tmpdeviceList.slice((page-1)*pageSize,((page-1)*pageSize)+pageSize)
    //     // this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})
    //     // console.log('onPageSizeChange',data)
    // }

    getNearTrackingList(){

        const name = this.state.poiName;
        const { user_id, user_name,token,poiId} = this.props;
        console.log('getNearTrackingList',this.state.poiId)
        fetch(`http://203.150.199.244/api/realtime/getNearTrackingList/${this.state.poiId}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
               
               "token": token
            },
            body: JSON.stringify({
                "filter":name
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                console.log(data)
                this.setState({
                    dataPoi:data.RESULT_DATA,
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }


    handleChange = (event) => {
        var val = event.target.value;

        this.setState({
            poiName: val
        });

        // this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    // getPOIList() {
    //     const name = this.state.poiName;
    //     const { token } = this.props;
    //     fetch("http://203.150.199.244/api/admin/getPOIList/1/20", {
    //         method: 'post',
    //         headers: {
    //             "Content-Type": "application/json; charset=utf-8",
    //            // "user_id": user_id,
    //            // "user_name": user_name,
    //            "token": token
    //         },
    //         body: JSON.stringify({
    //             "filter":name
    //         })
    //         })
    //         .then(response => response.json())
    //         .then(data => {
    //             this.setState({dataPoi:data.RESULT_DATA})

    //         })
    //         .catch(function (err) {
    //             console.log('err:', err);
    //             // POST failed...
    //         });


    //  }

    handleRowSelect1 = (row) => {
        const { onClickRowListTable } = this.props;
        onClickRowListTable(row)
    }

    // trStyle = (row, rowIndex) => {
    //     return { cursor: 'pointer'};
    // }

    editeDevice(device){

        this.setState({
            deviceSelectID:device.device_id,
            isShowEdit:true
        })
    }

    onEditDeviceClose(){
        this.btnEditClose.click();
        this.setState({
            isShowEdit:false
        })
    }

    deleteDevice(){

    }

    onClickSearch = () => {

        let name = this.state.poiName;

        this.setState({poiName:name});
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    onClickEdit = ()=>{
        console.log('edit')
        if(!checkPrivileges("edit_poi")){
            Alert("คุณไม่มีสิทธิ์ แก้ไขจุดสนใจได้","กรุณาติดต่อผู้ดูแล้วระบบ");
            return ;
        }
        const { openEdit } = this.props;
        openEdit();
        if(this.props.onClickUpdatePOI && this.props.onClickUpdatePOI!=null)
            this.props.onClickUpdatePOI(true);
    }

    

  render() {
    const {deviceSelectID,isShowNew,isShowEdit,deviceList,currentPageSize}=this.state;
    console.log(this.props.poiId)
    // const {  onClickDeletePoi } = this.props;
    // const flattenData = this.state.dataPoi.map((item,key) => {

    //     return {
    //         no:key+1,
    //         id:item.poi_id,
    //         name: item.name,
    //         group: item.group,
    //         radius: item.radius,
    //         lat:item.location.latitude,
    //         lng:item.location.longitude,
    //         email:item.alert.email,
    //         line_token:item.alert.line_token,
    //         is_entry:item.alert.when.is_entry,
    //         is_leave:item.alert.when.is_leave,
    //         icon:item.icon,

    //       };
    // });

    //       let rows = [];
    //       flattenData.map((device,key)=>{
    //         rows.push(
    //             <tr key={device.id}>
    //             <td >{key+1}</td>
    //             <td ><input type="checkbox" value="" /></td>
    //             <td>{device.name}</td>
    //             <td  style={{textAlign:'center'}}>{device.radius}</td>
    //             {/* <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Edit">
    //                 <button onClick={this.handleRowSelect1.bind(this, device)} className="btn btn-primary btn-xs" data-title="Edit" data-toggle="modal"
    //                 data-target="#editDevice"  data-backdrop="static" data-keyboard="false"><span className="fa fa-pencil" /></button></p></td>
                    
    //             <td><p data-placement="top" data-toggle="tooltip" title="Delete">
    //             <button  onClick={(e) => { e.preventDefault(); onClickDeletePoi(device); }}  className="btn btn-danger btn-xs" data-title="Delete" data-toggle="modal"
    //             data-target="#deleteDevice" data-backdrop="static" data-keyboard="false"><span className="fa fa-trash" /></button></p></td> */}
                
    //             </tr>
    //         )

    //     });

        const divStyle = {
            height: "calc(100vh - (122px))"
        }

        const onmouseOver = {
            cursor: 'pointer'
        }

        const options = {
            onRowClick: function(row) {
              alert(`You click row id: ${row.id}`);
            }
          };

          const selectRowProp = {
            mode: 'checkbox',
            // clickToSelect: true  // enable click to select
          };

    return (


        // <div className="gray-panel">
        <div className="gray-panel" >
           <div className="form-inline form-group row">
                <div className=" col-8">
                    <strong>รถที่อยู่ใกล้</strong>
                </div>
                
                <div className="col-4 text-right">
                     <input className="btn btn-primary btn-sm" id="focusedInput" type="button"  value="แก้ไข POI" onClick={this.onClickEdit} />
                </div>
            </div>
            
            {/* <div className="col-md-12 table-responsive">
                <table  className="table table-bordred table-striped table-hover ">
                <thead >
                    <tr>
                    <th style={{width:20}}></th>
                    <th style={{width:20}}></th>
                    <th>ชื่อสถานที่</th>
                    <th>รัศมี</th>
                    </tr></thead>
                <tbody>
                    {rows}
                </tbody>
                </table>

            </div> */}
            <div className="row">
                <div className="col-sm-12 table-responsive" style={{maxHeight:"30vh" ,overflowY:"auto"}}>
                    <table  className="table table-bordred table-striped table-hover ">
                    <thead >
                        <tr>
                        <th style={{width:20}}></th>
                        <th>ทะเบียน</th>
                        <th>สถานะ</th>
                        <th>ระยะ (กม.)</th>
                        </tr></thead>
                    <tbody>
                        {
                            this.state.dataPoi.map((device,key)=>{
                                return(
                                    <tr key={device.device_no} >
                                        <td >{key+1}</td>
                                        <td>{device.device_no}</td>
                                        <td >{device.status}</td>
                                        <td >{device.distance}</td>
                                    </tr>
                                )
                    
                            })
                        }
                    </tbody>
                    </table>
                </div>
            </div>
            {/* <BootstrapTable data={ flattenData } options={ options } striped hover condensed
                bodyStyle={ onmouseOver } 
                selectRow={ selectRowProp }
                
            >
                <TableHeaderColumn isKey={true} dataField='no' width='25'></TableHeaderColumn>
                <TableHeaderColumn dataField='name' >ชื่อสถานที่</TableHeaderColumn>
                <TableHeaderColumn dataField='radius'  width='50'>รัศมี</TableHeaderColumn>
            </BootstrapTable> */}
            {/* <RCPagination onSelect={this.onPageSelect.bind(this)} onShowSizeChange={this.onPageSizeChange.bind(this)} total={this.state.totalPage} pageSize={currentPageSize}/> */}
        </div>
    );
  }
}

NearTrackingList.propTypes = {
    onClickRowListTable: PropTypes.func.isRequired,
    userLevel: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onClickCancelEditPoi: PropTypes.func.isRequired,
    onClickConfirmEditPoi: PropTypes.func.isRequired,
    onClickDeletePoi: PropTypes.func.isRequired,
    openAdd:PropTypes.func,
    openEdit:PropTypes.func,
    poiId:PropTypes.string,
}

export default NearTrackingList;



// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/POI/NearTrackingList.js